<ng-container *ngIf="element.definitionId === 'piece-image' && element.settings?.general?.buttonBarToggle; then buttonBar"></ng-container>

<render-link
    *ngIf="!!element.settings && !!element.settings.general.link.type; else imageSelector"
    [link]="element.settings.general.link"
    [element]="element"
>
    <ng-container *ngTemplateOutlet="imageSelector"></ng-container>
</render-link>

<ng-template #imageSelector>
    <picture *ngIf="imageSrc$ | async as imageSrc">
        <!-- <ng-container *ngIf="!imageSrc.isSsr"> -->
        <img
            [lazyPieceImage]="imageSrc.src"
            [imageSkeleton]="imageSkeleton"
            [src]="imageSrc.skeleton"
            fixImageHeightSafari
            [aspectRatioSize]="imageSrc.aspectRatio"
            [attr.alt]="imageSrc.alt"
            [attr.title]="element.settings.general.title"
            [ngStyle]="{ borderRadius: element.settings.styles?.borderRadius }"
        />
        <div #imageSkeleton class="image-overlay"></div>
        <!-- </ng-container> -->
        <!-- <ng-container *ngIf="imageSrc.isSsr">
            <source *ngFor="let x of imageSrc.srcset" media="(max-width: {{ x.width }}px)" [srcset]="x.src" />
            <img
                [src]="imageSrc.src"
                fixImageHeightSafari
                [aspectRatioSize]="imageSrc.aspectRatio"
                [attr.alt]="imageSrc.alt"
                [attr.title]="element.settings.general.title"
                [ngStyle]="{ borderRadius: element.settings.styles?.borderRadius }"
            />
        </ng-container> -->
    </picture>

    <div *ngIf="element.definitionId === 'piece-image-text'" class="wysiwyg">
        <div class="wysiwyg-position">
            <ng-container
                *ngIf="element.settings.general.buttonBarToggle && element.settings.general.buttonBarPosition === 'up'; then buttonBar"
            ></ng-container>
            <render-wysiwyg
                *ngIf="element.settings?.general?.text"
                [html]="element.settings.general.text"
                [element]="element"
                [textPaddingTop]="element.settings.general.textPaddingTop"
                [textPaddingBottom]="element.settings.general.textPaddingBottom"
                [textPaddingLeft]="element.settings.general.textPaddingLeft"
                [textPaddingRight]="element.settings.general.textPaddingRight"
            >
            </render-wysiwyg>
            <ng-container
                *ngIf="element.settings.general.buttonBarToggle && element.settings.general.buttonBarPosition === 'down'; then buttonBar"
            ></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #buttonBar>
    <div class="button-bar-container" [ngClass]="element.settings.general.buttonBarPosition">
        <ul class="button-bar">
            <li *ngFor="let button of element.settings.general.buttons; trackBy: trackByIndex">
                <render-link [link]="button.link" [styleClass]="button.style" [element]="element">
                    {{ button.title }}
                </render-link>
            </li>
        </ul>
    </div>
</ng-template>
